"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const api_1 = require("./descriptors/api");
const common_1 = require("./handlers/deprecated/common");
const invalid_1 = require("./handlers/invalid");
const leven_1 = require("./handlers/unknown/leven");
exports.defaultDescriptor = api_1.apiDescriptor;
exports.defaultUnknownHandler = leven_1.levenUnknownHandler;
exports.defaultInvalidHandler = invalid_1.commonInvalidHandler;
exports.defaultDeprecatedHandler = common_1.commonDeprecatedHandler;
